import { APP_BAR_STATIC_WIDTH } from 'owa-layout';
import { DEFAULT_FOLDER_PANE_WIDTH } from '../internalConstants';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Gets the current padding left of search box.
 * @returns the number of pixels
 */
export default function getSearchBoxLeftPadding(): number {
    const navBarWidth =
        getUserConfiguration().UserOptions?.NavigationBarWidth || DEFAULT_FOLDER_PANE_WIDTH;

    return navBarWidth + APP_BAR_STATIC_WIDTH;
}
